import React from 'react';
import NavContainer from "./components/Nav";
import OffCanvasNav from './components/OffCanvasNav';
import Dashboard from './components/DashBoard';
import GroomerDashboard from './components/GroomerDashboard';
import WelcomeScreen from './components/WelcomeScreen';
import { Helmet } from 'react-helmet';
import { useAuth } from './context/AuthContext';
import { useBranding } from './context/BrandingContext';
import { Spinner, Container } from 'react-bootstrap';



const App = () => {
  const { roleId } = useAuth();
  const { companyName } = useBranding();
  
  console.log('Role ID:', roleId);

  // Mostrar loading mientras se obtiene el rol
  if (roleId === null) {
    return (
      <>
        <NavContainer></NavContainer>
        <OffCanvasNav></OffCanvasNav>
        <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
          <Spinner animation="border" variant="primary" />
        </Container>
      </>
    );
  }

  // Verificar roles
  const isAdmin = parseInt(roleId) === 1;
  // Asumiendo que el rol de Groomer tiene id_role = 2 (ajusta según tu base de datos)
  const isGroomer = parseInt(roleId) === 3;

  return (
    <>
      <NavContainer></NavContainer>
      <OffCanvasNav></OffCanvasNav>
      <Helmet><title>
        {isAdmin ? `Dashboard - ${companyName}` : isGroomer ? `Dashboard Groomer - ${companyName}` : `Inicio - ${companyName}`}
      </title></Helmet>
      {isAdmin ? <Dashboard /> : isGroomer ? <GroomerDashboard /> : <WelcomeScreen />}
    </>
  );
}

export default App;